import script from "./LeadManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadManagement.vue?vue&type=script&setup=true&lang=js"

import "./LeadManagement.vue?vue&type=style&index=0&id=b301c5b0&scoped=true&lang=css"
import "./LeadManagement.vue?vue&type=style&index=1&id=b301c5b0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b301c5b0"]])

export default __exports__